import React, { useEffect } from 'react'
import './index.css'
import { Button } from 'antd'
import { useDispatch, useSelector } from 'react-redux'

const NotificationComponent: React.FC = () => {
  const apps = useSelector((state: any) => state.apps)

  const dispatch = useDispatch()

  const duration = 5

  useEffect(() => {
    const timer = setTimeout(() => {
      // Info toasts stay (in-progress messages) unless the sender opts into auto-close.
      if (apps.notification_type !== 'info' || apps.notification_auto_close) {
        dispatch({
          type: 'apps/RESET_NOTIFICATION',
        })
      }
    }, duration * 1000)

    return () => {
      clearTimeout(timer)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, apps.notification_message])

  const handleCloseNotification = () => {
    dispatch({
      type: 'apps/RESET_NOTIFICATION',
    })
  }

  const getBackgroundColor = () => {
    if (apps.notification_type === 'success') {
      return 'styleSuccessIcon'
    }
    if (apps.notification_type === 'error') {
      return 'styleFailIcon'
    }
    return 'styleInfoIcon'
  }

  return (
    <>
      {apps.notification_message !== '' ? (
        <div style={{ zIndex: '10' }}>
          <div className="divBox">
            <div className={getBackgroundColor()} />
            <div className="divTextNotification">{apps.notification_message}</div>
            <Button onClick={handleCloseNotification} className="buttonCloseNotification">
              <div className="styleCancelIcon" />
            </Button>
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  )
}

export default NotificationComponent
